import PrintSupplierPartsReportMenuItem from "@/main/components/shared/printSupplierPartsReport/printSupplierPartsReportMenuItem";
import { useThreeDotsClaimContext } from "@/main/screens/claim/searchClaim/gridSearchClaim/rowSearchClaim/collapseSearchClaim/headerCollapseSearchClaim/threeDotsClaim/contex";
import { Controls } from "@/main/services/constants/constantsControl";

interface IThreeDotsClaimPrintSupplierPartsReport {
	guidClaim: string;
}

function ThreeDotsClaimPrintSupplierPartsReport({ guidClaim }: Readonly<IThreeDotsClaimPrintSupplierPartsReport>) {
	const { setAnchorEl } = useThreeDotsClaimContext();

	return (
		<PrintSupplierPartsReportMenuItem
			id="id-option-button-printSupplierPartsReport"
			controlId={Controls.IdPrintSupplierPartsReportSearchClaims}
			guidClaim={guidClaim}
			onClose={() => setAnchorEl(null)}
		/>
	);
}

export { ThreeDotsClaimPrintSupplierPartsReport };
